// Helper apiFetch — centralise les appels API de la console opérateur.
//
// Web : comportement identique à un fetch() ordinaire (same-origin, cookies).
// Natif : préfixe le chemin par l'URL absolue du relay et injecte
//         `Authorization: Bearer <token>` sur chaque requête.

import { apiOrigin, isNativeApp } from "./native";
import { getNativeToken } from "./native-token";

/**
 * Effectue un fetch vers l'API relay.
 *
 * @param path  Chemin absolu commençant par "/" (ex: "/api/ws-token")
 * @param init  Options fetch optionnelles (headers, method, body…)
 */
export async function apiFetch(path: string, init: RequestInit = {}): Promise<Response> {
  const url = isNativeApp() ? `${apiOrigin()}${path}` : path;

  const headers = new Headers(init.headers);

  if (isNativeApp()) {
    const token = getNativeToken();
    if (token) {
      headers.set("Authorization", `Bearer ${token}`);
    }
  } else {
    // Sur le web, les cookies sont envoyés automatiquement (same-origin).
    // credentials: "include" est déjà dans certains call-sites ; on s'assure
    // que le défaut "same-origin" ne casse rien en ne l'imposant pas ici.
  }

  return fetch(url, { ...init, headers });
}
